<template>
  <div id="calculator-loader" class="modal modal-fixed-footer" ref="modal">
    <div class="modal-content" style="padding:0px;">
      <div class="modal-title">{{ titleX }}</div>
      <non-essential-needs-calculator v-if="showCalculator === 'non'" />
      <essential-needs-calculator v-else-if="showCalculator === 'essential'" />
      <energy-calculator v-else />
    </div>
    <div class="modal-footer">
      <button @click="$_close()" class="waves-effect waves-black btn-flat btn">
        Close
      </button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import EssentialNeedsCalculator from "./EssentialNeedsCalculator";
import EnergyCalculator from "./EnergyCalculator";
import NonEssentialNeedsCalculator from "./NonEssentialNeedsCalculator";

export default {
  components: {
    NonEssentialNeedsCalculator,
    EssentialNeedsCalculator,
    EnergyCalculator,
  },
  name: "CalculatorLoader",
  props: {},
  data() {
    let vm = this;
    return {
      modal: {
        instance: null,
        options: {
          onCloseEnd: () => {
            this.setShowCalculator(false);
          }
        },
      },
    };
  },
  mounted() {
    this.$_initModal();
  },
  beforeDestroy() {
    this.modal.instance.close()
    if (this.modal.instance) {
      this.setShowCalculator(false);
      this.modal.instance.destroy();
    }
  },
  computed: {
    ...mapState({
      showCalculator: (state) => state.Main.showCalculator,
    }),

    titleX() {
      if (this.calculatorToShow === "non") {
        return "Non-essential Household Needs Calculator";
      } else if (this.calculatorToShow === "essential") {
        return "Essential Household Needs Calculator";
      }
      return "Energy Calculator";
    },
  },
  methods: {
    ...mapActions("Main", ["setShowCalculator"]),
    $_initModal() {
      this.modal.instance = M.Modal.init(this.$refs.modal, this.modal.options);
      setTimeout(() => {
        this.modal.instance.open();
      });
    },

    $_close() {
      this.modal.instance.close();
      this.setShowCalculator(false);
    },
  },
};
</script>
<style lang="scss" scoped>
#calculator-loader {
  &.modal {
    width: 95%;
    min-height: calc(100% - 68px);
    top: 10px !important;
    border-radius: 6px;
  }
}
</style>
